// OSIS - Platformă E-learning - Specializată pentru industria proiectelor și lucrărilor
import React, { useState } from 'react';
import { 
  BookOpen, PlayCircle, Award, Clock, Users, TrendingUp, Plus, Search, Filter, Star, 
  CheckCircle, BarChart3, Download, User, Target, Coffee, Factory, Wrench, Ruler,
  PenTool, Shield, Thermometer, Eye, Edit3
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';
import { mockData } from '../../utils/mockData';

const PlatformaElearning = () => {
  const [showCourseModal, setShowCourseModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [filterCategory, setFilterCategory] = useState('Toate');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState('Toți');

  // Cursuri specializate OSIS pentru industria proiectelor și lucrărilor
  const elearningData = {
    overview: {
      totalCourses: 18,
      completedCourses: 14,
      inProgressCourses: 3,
      certificatesEarned: 11
    },
    courses: [
      {
        id: 1,
        title: 'Tehnologii Avansate epoxidic pentru proiecte',
        category: 'Producție Specializată',
        instructor: 'Ing. Radu Petcu - Sika',
        duration: '12 ore',
        level: 'Avansat',
        progress: 100,
        rating: 4.9,
        status: 'Finalizat',
        completedDate: '2024-02-15',
        description: 'Tehnici moderne de procesare rășini epoxidice și optimizarea proceselor de fabricație',
        modules: 8,
        price: '680 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['epoxidic', 'Fabricație', 'Sika', 'Tehnologii'],
        thumbnail: 'epoxidic-advanced.jpg',
        lastUpdated: '2024-01-20',
        certificateEarned: true,
        skillsGained: ['Profile multi-cameră', 'aplicare rășini', 'Control calitate', 'Optimizare producție'],
        targetEmployees: ['Bărbosu Mihăiță - Daniel', 'Cojocariu Beniamin', 'Loghin Petrică - Ionuț'],
        completedBy: ['Bărbosu Mihăiță - Daniel', 'Cojocariu Beniamin']
      },
      {
        id: 2,
        title: 'AutoCAD pentru Proiectare pardoseli industriale',
        category: 'Tehnică și Proiectare',
        instructor: 'Arh. Mircea Stancu',
        duration: '16 ore',
        level: 'Intermediar',
        progress: 85,
        rating: 4.8,
        status: 'În progres',
        description: 'Specializare în proiectarea tehnică cu AutoCAD pentru industria proiectelor',
        modules: 12,
        price: '850 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['AutoCAD', 'Proiectare', 'Desene Tehnice', '2D/3D'],
        thumbnail: 'autocad-windows.jpg',
        lastUpdated: '2024-03-01',
        certificateEarned: false,
        skillsGained: ['Desenarea profilelor', 'Planuri de execuție', 'Calcule dimensiuni', 'Randare 3D'],
        targetEmployees: ['Filip Paul - Ionel', 'Simion Tiberiu'],
        completedBy: ['Filip Paul - Ionel']
      },
      {
        id: 3,
        title: 'Certificare Aplicare Pardoseli - Nivel 1',
        category: 'Instalare și Montaj',
        instructor: 'Master Vasile Gheorghiu',
        duration: '20 ore',
        level: 'Începător',
        progress: 100,
        rating: 4.7,
        status: 'Finalizat',
        completedDate: '2023-11-30',
        description: 'Curs fundamental pentru tehnicile corecte de instalare pardoseli industriale',
        modules: 10,
        price: '750 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Montaj', 'Instalare', 'Certificare', 'Siguranța muncii'],
        thumbnail: 'installation-cert.jpg',
        lastUpdated: '2023-10-15',
        certificateEarned: true,
        skillsGained: ['Tehnici montaj', 'Izolație termică', 'Siguranța muncii', 'Unelte specializate'],
        targetEmployees: ['Ungureanu Ștefan', 'Murariu Iulian - Eusebiu', 'Cojocariu Beniamin'],
        completedBy: ['Ungureanu Ștefan', 'Murariu Iulian - Eusebiu', 'Cojocariu Beniamin']
      },
      {
        id: 4,
        title: 'Marketing Digital pentru Industria Construcțiilor',
        category: 'Marketing și Vânzări',
        instructor: 'Specialist Ana Dobre',
        duration: '14 ore',
        level: 'Intermediar',
        progress: 60,
        rating: 4.6,
        status: 'În progres',
        description: 'Strategii de marketing online specializate pentru pardoseli industriale și construcții',
        modules: 9,
        price: '620 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Marketing Digital', 'Construcții', 'Social Media', 'Google Ads'],
        thumbnail: 'marketing-construction.jpg',
        lastUpdated: '2024-02-28',
        certificateEarned: false,
        skillsGained: ['Facebook Ads', 'Google My Business', 'Content Marketing', 'SEO local'],
        targetEmployees: ['Moroșan Noemia', 'Aostăcioaei Dumitru - Ciprian'],
        completedBy: []
      },
      {
        id: 5,
        title: 'Sisteme de Securitate pentru lucrări Blindate',
        category: 'Securitate și Siguranță',
        instructor: 'Ing. Dan Mărculescu - Expert Securitate',
        duration: '10 ore',
        level: 'Avansat',
        progress: 100,
        rating: 4.9,
        status: 'Finalizat',
        completedDate: '2024-01-20',
        description: 'Tehnologii moderne de securitate și sisteme de închidere pentru lucrări blindate',
        modules: 6,
        price: '890 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Securitate', 'lucrări Blindate', 'Sisteme Închidere', 'Tehnologie'],
        thumbnail: 'security-doors.jpg',
        lastUpdated: '2024-01-10',
        certificateEarned: true,
        skillsGained: ['Sisteme multipoint', 'Cilindri securitate', 'Verificare rezistență', 'Instalare avansată'],
        targetEmployees: ['Ungureanu Ștefan', 'Cojocariu Beniamin'],
        completedBy: ['Ungureanu Ștefan', 'Cojocariu Beniamin']
      },
      {
        id: 6,
        title: 'Eficiența Energetică în Construcții',
        category: 'Performanță Energetică',
        instructor: 'Dr. Ing. Elena Radu',
        duration: '8 ore',
        level: 'Intermediar',
        progress: 100,
        rating: 4.5,
        status: 'Finalizat',
        completedDate: '2023-12-10',
        description: 'Principii de eficiență energetică și calcularea performanțelor termice',
        modules: 5,
        price: '480 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['Eficiență Energetică', 'pardoseală', 'Certificat Energetic', 'Izolație'],
        thumbnail: 'energy-efficiency.jpg',
        lastUpdated: '2023-11-25',
        certificateEarned: true,
        skillsGained: ['Calcul coeficient U', 'Alegere sticle', 'Poduri termice', 'Certificare energetică'],
        targetEmployees: ['Filip Paul - Ionel', 'Simion Tiberiu', 'Aostăcioaei Dumitru - Ciprian'],
        completedBy: ['Filip Paul - Ionel', 'Simion Tiberiu']
      },
      {
        id: 7,
        title: 'Management Calitate ISO 9001',
        category: 'Management și Calitate',
        instructor: 'Consultant Maria Gheorghe',
        duration: '18 ore',
        level: 'Avansat',
        progress: 30,
        rating: 4.4,
        status: 'În progres',
        description: 'Implementarea sistemului de management al calității conform ISO 9001',
        modules: 12,
        price: '950 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['ISO 9001', 'Calitate', 'Management', 'Proceduri'],
        thumbnail: 'iso-9001.jpg',
        lastUpdated: '2024-03-15',
        certificateEarned: false,
        skillsGained: ['Proceduri calitate', 'Audit intern', 'Non-conformități', 'Îmbunătățire continuă'],
        targetEmployees: ['Aostăcioaei Dumitru - Ciprian', 'Cazacu Denisa - Elena', 'Bărbosu Mihăiță - Daniel'],
        completedBy: []
      },
      {
        id: 8,
        title: 'Siguranța și Sănătatea în Muncă - Construcții',
        category: 'Siguranța Muncii',
        instructor: 'Ing. Andrei Popescu - Inspector SSM',
        duration: '6 ore',
        level: 'Obligatoriu',
        progress: 100,
        rating: 4.7,
        status: 'Finalizat',
        completedDate: '2024-01-15',
        description: 'Cursul obligatoriu SSM pentru activitățile de producție și montaj în construcții',
        modules: 4,
        price: '320 RON',
        language: 'Română',
        hasQuiz: true,
        hasCertificate: true,
        tags: ['SSM', 'Siguranța Muncii', 'Construcții', 'Obligatoriu'],
        thumbnail: 'work-safety.jpg',
        lastUpdated: '2024-01-01',
        certificateEarned: true,
        skillsGained: ['Proceduri SSM', 'EPI obligatorii', 'Evaluare riscuri', 'Primul ajutor'],
        targetEmployees: ['Toți angajații OSIS'],
        completedBy: mockData.employees.map(emp => emp.name)
      }
    ]
  };

  // Statistici pe departamente
  const departmentProgress = [
    {
      department: 'Management',
      totalCourses: 6,
      completed: 4,
      inProgress: 1,
      employees: mockData.employees.filter(emp => emp.department === 'Management').length,
      avgProgress: 78
    },
    {
      department: 'Tehnică',
      totalCourses: 8,
      completed: 6,
      inProgress: 2,
      employees: mockData.employees.filter(emp => emp.department === 'Tehnică').length,
      avgProgress: 85
    },
    {
      department: 'Producție',
      totalCourses: 5,
      completed: 4,
      inProgress: 1,
      employees: mockData.employees.filter(emp => emp.department === 'Producție').length,
      avgProgress: 92
    },
    {
      department: 'Montaj',
      totalCourses: 4,
      completed: 4,
      inProgress: 0,
      employees: mockData.employees.filter(emp => emp.department === 'Montaj').length,
      avgProgress: 100
    }
  ];

  const categories = [
    'Toate',
    'Producție Specializată',
    'Tehnică și Proiectare', 
    'Instalare și Montaj',
    'Marketing și Vânzări',
    'Securitate și Siguranță',
    'Performanță Energetică',
    'Management și Calitate',
    'Siguranța Muncii'
  ];

  const filteredCourses = elearningData.courses.filter(course => {
    const matchesCategory = filterCategory === 'Toate' || course.category === filterCategory;
    const matchesSearch = course.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         course.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesEmployee = selectedEmployee === 'Toți' || 
                            course.targetEmployees.includes(selectedEmployee) ||
                            course.completedBy.includes(selectedEmployee);
    return matchesCategory && matchesSearch && matchesEmployee;
  });

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Producție Specializată': return Factory;
      case 'Tehnică și Proiectare': return PenTool;
      case 'Instalare și Montaj': return Wrench;
      case 'Marketing și Vânzări': return TrendingUp;
      case 'Securitate și Siguranță': return Shield;
      case 'Performanță Energetică': return Thermometer;
      case 'Management și Calitate': return Award;
      case 'Siguranța Muncii': return Shield;
      default: return BookOpen;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Finalizat': return 'success';
      case 'În progres': return 'warning';
      case 'Nou': return 'info';
      case 'Planificat': return 'secondary';
      default: return 'default';
    }
  };

  const getLevelColor = (level) => {
    switch (level) {
      case 'Începător': return 'success';
      case 'Intermediar': return 'warning';
      case 'Avansat': return 'error';
      case 'Obligatoriu': return 'info';
      default: return 'default';
    }
  };

  const courseTableColumns = [
    {
      header: 'Curs',
      key: 'title',
      render: (value, row) => {
        const Icon = getCategoryIcon(row.category);
        return (
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <Icon className="w-5 h-5 text-primary-600 mt-1" />
            </div>
            <div>
              <p className="font-semibold text-gray-900 dark:text-white">{value}</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">{row.instructor}</p>
              <div className="flex items-center space-x-2 mt-1">
                <Badge variant="secondary" className="text-xs">{row.category}</Badge>
                <Badge variant={getLevelColor(row.level)} className="text-xs">{row.level}</Badge>
              </div>
            </div>
          </div>
        );
      }
    },
    {
      header: 'Progres',
      key: 'progress',
      render: (value, row) => (
        <div className="flex items-center space-x-3">
          <div className="flex-1">
            <div className="flex items-center justify-between mb-1">
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{value}%</span>
              <Badge variant={getStatusColor(row.status)} className="text-xs">{row.status}</Badge>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
              <div 
                className={`h-2 rounded-full transition-all duration-300 ${
                  value === 100 ? 'bg-green-500' : 
                  value >= 50 ? 'bg-yellow-500' : 'bg-blue-500'
                }`}
                style={{ width: `${value}%` }}
              ></div>
            </div>
          </div>
        </div>
      )
    },
    {
      header: 'Detalii',
      key: 'details',
      render: (_, row) => (
        <div className="text-sm text-gray-600 dark:text-gray-400">
          <div className="flex items-center space-x-4 mb-1">
            <span className="flex items-center">
              <Clock className="w-3 h-3 mr-1" />
              {row.duration}
            </span>
            <span className="flex items-center">
              <Star className="w-3 h-3 mr-1 text-yellow-400" />
              {row.rating}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            {row.hasCertificate && <CheckCircle className="w-3 h-3 text-green-500" />}
            <span className="text-xs">{row.modules} module</span>
          </div>
        </div>
      )
    },
    {
      header: 'Echipă Țintă',
      key: 'targetEmployees',
      render: (value) => (
        <div className="space-y-1">
          {value.slice(0, 2).map((employee, index) => (
            <div key={index} className="text-xs bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded">
              {employee}
            </div>
          ))}
          {value.length > 2 && (
            <div className="text-xs text-gray-500">+{value.length - 2} alții</div>
          )}
        </div>
      )
    },
    {
      header: 'Acțiuni',
      key: 'actions',
      render: (_, row) => (
        <div className="flex items-center space-x-2">
          <button 
            onClick={() => {
              setSelectedCourse(row);
              setShowCourseModal(true);
            }}
            className="text-primary-600 hover:text-primary-800 dark:text-primary-400"
            title="Vezi detalii"
          >
            <Eye className="w-4 h-4" />
          </button>
          <button 
            className="text-gray-600 hover:text-gray-800 dark:text-gray-400"
            title="Editează"
          >
            <Edit3 className="w-4 h-4" />
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          <Factory className="w-8 h-8 text-primary-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center">
              <BookOpen className="w-6 h-6 mr-2 text-secondary-600" />
              Platformă E-learning OSIS
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-2">
              Cursuri specializate pentru echipa OSIS - pardoseli industriale • 11 angajați în formare
            </p>
          </div>
        </div>
        
        <button 
          onClick={() => setShowCourseModal(true)}
          className="btn btn-primary flex items-center space-x-2"
        >
          <Plus className="w-4 h-4" />
          <span>Curs Nou</span>
        </button>
      </div>

      {/* Overview Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card>
          <div className="flex items-center space-x-3">
            <BookOpen className="w-8 h-8 text-blue-600" />
            <div>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{elearningData.overview.totalCourses}</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">Cursuri Totale</p>
            </div>
          </div>
        </Card>

        <Card>
          <div className="flex items-center space-x-3">
            <CheckCircle className="w-8 h-8 text-green-600" />
            <div>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{elearningData.overview.completedCourses}</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">Finalizate</p>
            </div>
          </div>
        </Card>

        <Card>
          <div className="flex items-center space-x-3">
            <Clock className="w-8 h-8 text-yellow-600" />
            <div>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{elearningData.overview.inProgressCourses}</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">În Progres</p>
            </div>
          </div>
        </Card>

        <Card>
          <div className="flex items-center space-x-3">
            <Award className="w-8 h-8 text-purple-600" />
            <div>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{elearningData.overview.certificatesEarned}</p>
              <p className="text-sm text-gray-600 dark:text-gray-400">Certificate</p>
            </div>
          </div>
        </Card>
      </div>

      {/* Progress by Department */}
      <Card title="Progres pe Departamente OSIS" icon={BarChart3}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {departmentProgress.map((dept, index) => (
            <div key={index} className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
              <div className="flex items-center justify-between mb-3">
                <h4 className="font-medium text-gray-900 dark:text-white">{dept.department}</h4>
                <span className="text-sm text-gray-500">{dept.employees} ang.</span>
              </div>
              
              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span>Finalizate:</span>
                  <span className="font-medium">{dept.completed}/{dept.totalCourses}</span>
                </div>
                
                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                  <div 
                    className="bg-primary-500 h-2 rounded-full transition-all duration-300"
                    style={{ width: `${dept.avgProgress}%` }}
                  ></div>
                </div>
                
                <div className="flex justify-between text-sm">
                  <span>Progres mediu:</span>
                  <span className="font-medium text-primary-600">{dept.avgProgress}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>

      {/* Filters */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4 mb-6">
          <div className="flex-1 relative">
            <Search className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
            <input
              type="text"
              placeholder="Caută cursuri OSIS..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
            />
          </div>
          
          <select
            value={filterCategory}
            onChange={(e) => setFilterCategory(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            {categories.map(category => (
              <option key={category} value={category}>{category}</option>
            ))}
          </select>
          
          <select
            value={selectedEmployee}
            onChange={(e) => setSelectedEmployee(e.target.value)}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:text-white"
          >
            <option value="Toți">Toți angajații</option>
            {mockData.employees.map(employee => (
              <option key={employee.id} value={employee.name}>{employee.name}</option>
            ))}
          </select>
        </div>

        <Table 
          columns={courseTableColumns}
          data={filteredCourses}
        />
      </Card>

      {/* Course Detail Modal */}
      {selectedCourse && (
        <Modal
          isOpen={showCourseModal}
          onClose={() => {
            setShowCourseModal(false);
            setSelectedCourse(null);
          }}
          title={selectedCourse.title}
          size="lg"
        >
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-gray-900 dark:text-white mb-2">Detalii Curs</h3>
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Instructor:</span>
                      <span className="font-medium">{selectedCourse.instructor}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Durată:</span>
                      <span className="font-medium">{selectedCourse.duration}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Nivel:</span>
                      <Badge variant={getLevelColor(selectedCourse.level)} className="text-xs">
                        {selectedCourse.level}
                      </Badge>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Module:</span>
                      <span className="font-medium">{selectedCourse.modules}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-500">Rating:</span>
                      <div className="flex items-center">
                        <Star className="w-4 h-4 text-yellow-400 mr-1" />
                        <span className="font-medium">{selectedCourse.rating}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Progres</h4>
                  <div className="flex items-center space-x-3">
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-3">
                      <div 
                        className={`h-3 rounded-full ${
                          selectedCourse.progress === 100 ? 'bg-green-500' : 
                          selectedCourse.progress >= 50 ? 'bg-yellow-500' : 'bg-blue-500'
                        }`}
                        style={{ width: `${selectedCourse.progress}%` }}
                      ></div>
                    </div>
                    <span className="font-medium">{selectedCourse.progress}%</span>
                  </div>
                  <Badge variant={getStatusColor(selectedCourse.status)} className="mt-2 text-xs">
                    {selectedCourse.status}
                  </Badge>
                </div>
              </div>

              <div className="space-y-4">
                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Competențe Dobândite</h4>
                  <div className="flex flex-wrap gap-2">
                    {selectedCourse.skillsGained?.map((skill, index) => (
                      <Badge key={index} variant="info" className="text-xs">
                        {skill}
                      </Badge>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Echipa Țintă</h4>
                  <div className="space-y-1">
                    {selectedCourse.targetEmployees?.map((employee, index) => (
                      <div key={index} className="text-sm bg-gray-100 dark:bg-gray-800 px-2 py-1 rounded">
                        {employee}
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <h4 className="font-medium text-gray-900 dark:text-white mb-2">Finalizat de</h4>
                  <div className="space-y-1">
                    {selectedCourse.completedBy?.length > 0 ? (
                      selectedCourse.completedBy.map((employee, index) => (
                        <div key={index} className="text-sm bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 px-2 py-1 rounded">
                          ✓ {employee}
                        </div>
                      ))
                    ) : (
                      <div className="text-sm text-gray-500">Nimeni încă</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h4 className="font-medium text-gray-900 dark:text-white mb-2">Descriere</h4>
              <p className="text-gray-600 dark:text-gray-400 text-sm">{selectedCourse.description}</p>
            </div>

            <div className="flex justify-end space-x-3 pt-4 border-t dark:border-gray-700">
              <button
                onClick={() => {
                  setShowCourseModal(false);
                  setSelectedCourse(null);
                }}
                className="btn btn-secondary"
              >
                Închide
              </button>
              <button className="btn btn-primary flex items-center space-x-2">
                <PlayCircle className="w-4 h-4" />
                <span>Începe Cursul</span>
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default PlatformaElearning;